import Fulllayout from '../layouts/fulllayout.js';

var indexRoutes = [
    { path: '/', name: 'Home', component: Fulllayout }
];

export default indexRoutes;
